import React, { useState } from 'react';
// logic
import ticketService from 'modules/emergencies/ticketService';
// components
import { FormButton } from '../ui/buttons/FormButton';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import {
  ModalContainer,
  CloseButtonContainer,
  ModalBody,
  ModalFooter,
  ModalFormContainer,
  ModalHeader,
  ModalHeaderInnerContainer,
  ModalHeaderMainText,
  ModalHeaderSecondaryText,
  CheckboxInputContainer,
  RadioInputsContainer,
  ModalBoldText,
} from './modalComponents';
import CheckBoxLabel from '../ticketForm/components/CheckBoxLabel';
import { Half } from '../ticketForm/components/Half';
import styled from 'styled-components';
import ChangesSummary from '../changesSummary/changesSummary';

const CustomModalFormContainer = styled(ModalFormContainer)`
  display: flex;
  flex-direction: row;
`;

const CustomHalf = styled(Half)`
  gap: 16px;
  display: flex;
  flex-direction: column;
`;

const t = {
  confirm: 'Save changes',
  back: 'Back',
  title: 'Do you want to save the changes?',
  price_change_reasons: 'Price change reasons',
  cost_change_reasons: 'Cost change reasons',
};
export const ConfirmQuoteEditionAfterAcceptanceModal = ({ ok, cancel, props }) => {
  const { changes, ticket } = props;

  const goBack = (e) => {
    e.preventDefault();
    cancel();
  };
  const formattedTicketId = ticketService.utils.getFormatedId(ticket.id);
  const availableReasons = {
    ERROR_IN_CREATION: 'Error in creation',
    CHANGE_REQUESTED_BY_SHIPPER_OR_CARRIER: 'Change requested by shipper or carrier',
    ETRA_CHARGES: 'Extra charges',
  };
  const initialReasonForPriceChange = changes.price ? Object.keys(availableReasons)[0] : '';
  const [changeReason, setChangeReason] = useState(initialReasonForPriceChange);
  const initialReasonForCosteChange = changes.cost ? Object.keys(availableReasons)[0] : '';
  const [costChangeReason, setCostChangeReason] = useState(initialReasonForCosteChange);

  return (
    <ModalContainer>
      <ModalBody>
        <ModalHeader>
          <ModalHeaderInnerContainer>
            <ModalHeaderSecondaryText>{`Quote - Ticket ID. ${formattedTicketId}`}</ModalHeaderSecondaryText>
            <ModalHeaderMainText>{t.title}</ModalHeaderMainText>
          </ModalHeaderInnerContainer>
        </ModalHeader>
        <CustomModalFormContainer>
          <ChangesSummary changes={changes} />
        </CustomModalFormContainer>
        <CustomModalFormContainer>
          {changes.price && (
            <CustomHalf>
              <ModalBoldText>{t.price_change_reasons}</ModalBoldText>
              <RadioInputsContainer>
                {Object.keys(availableReasons).map((key) => (
                  <CheckboxInputContainer key={key} onClick={() => setChangeReason(key)}>
                    {key === changeReason ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <circle cx="10" cy="10" r="10" fill="#2396DC" />
                        <circle cx="10" cy="10" r="4" fill="white" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <circle cx="10" cy="10" r="9.5" fill="white" stroke="#E2E8EE" />
                      </svg>
                    )}

                    <CheckBoxLabel>{availableReasons[key]}</CheckBoxLabel>
                  </CheckboxInputContainer>
                ))}
              </RadioInputsContainer>
            </CustomHalf>
          )}
          {changes.cost && (
            <CustomHalf>
              <ModalBoldText>{t.cost_change_reasons}</ModalBoldText>
              <RadioInputsContainer>
                {Object.keys(availableReasons).map((key) => (
                  <CheckboxInputContainer key={key} onClick={() => setCostChangeReason(key)}>
                    {key === costChangeReason ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <circle cx="10" cy="10" r="10" fill="#2396DC" />
                        <circle cx="10" cy="10" r="4" fill="white" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <circle cx="10" cy="10" r="9.5" fill="white" stroke="#E2E8EE" />
                      </svg>
                    )}

                    <CheckBoxLabel>{availableReasons[key]}</CheckBoxLabel>
                  </CheckboxInputContainer>
                ))}
              </RadioInputsContainer>
            </CustomHalf>
          )}
        </CustomModalFormContainer>
      </ModalBody>
      <ModalFooter>
        <FormButton variant="ghost" onClick={goBack}>
          {t.back}
        </FormButton>
        <FormButton
          onClick={() =>
            ok({
              change_reason: changeReason,
              cost_change_reason: costChangeReason,
            })
          }
        >
          {t.confirm}
        </FormButton>
      </ModalFooter>
      <CloseButtonContainer onClick={goBack}>
        <CloseIcon />
      </CloseButtonContainer>
    </ModalContainer>
  );
};
